import { Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import CustomButton from "../components/CustomButton";
import ImageLoader from "../components/ImageLoader";
import { useContext } from "react";
import { ScreenContext } from "../context/ScreenContext";
import { useLocation, useNavigate } from "react-router-dom";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";

const ServiceItem = ({ title, description, image, reverse, color }) => {
  /**
   * Valores extraídos del contexto `ScreenContext`, que proporcionan información sobre la pantalla.
   * `isMobile` es un valor booleano que indica si la vista actual corresponde a un dispositivo móvil.
   * `dimensionHeight` es la altura de la ventana del navegador.
   * @type {{isMobile: boolean, dimensionHeight: number}} Un objeto con las propiedades `isMobile` y `dimensionHeight`.
   */
  const { isMobile } = useContext(ScreenContext);
  const navigate = useNavigate();

  const location = useLocation();

  const handleWhatsApp = () => {
    trackEvent(`${title}_whatsapp`, {
      page_path: location.pathname,
      page_url: window.location.href,
      section: `${title}_WhatsApp`,
      cta_name: "enviar_mensaje",
      value: 1,
    });

    openWhatsApp(
      "525959570961",
      `Hola Centro Médico MEDAM 👋, me gustaría recibir información sobre ${title}.`,
      true,
    );
  };

  return (
    <Grid
      container
      width="100%"
      mt={4}
      flexDirection={reverse ? "row-reverse" : "row"}
    >
      <Grid size={design.Grid1} />
      <Grid size={design.Grid5} alignSelf="center">
        <CustomText
          variant="subtitle1"
          color={color}
          text=""
          sx={design.TextTitulo}
        >
          {title}
        </CustomText>
        <CustomText
          variant="subtitle1"
          color="#000"
          text=""
          sx={design.Description}
        >
          {description}
        </CustomText>
        <Grid container>
          <Grid size={design.Grid6} alignSelf="center">
            <CustomText
              variant="subtitle1"
              color="#2349D0"
              text=""
              sx={design.Medico}
              onClick={() => navigate("/medicalDirectory")}
            >
              Buscar médico
            </CustomText>
          </Grid>
          <Grid size={design.Grid7}>
            <CustomButton
              type="submit"
              variant="contained"
              color="success"
              colorTexto="#FFF"
              backgroundColor="#489E4D"
              width="95%"
              height={50}
              grid={12}
              gridXS={12}
              borderRadius={10}
              style={design.Button}
              onClick={handleWhatsApp}
            >
              Agendar cita
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item size={design.Grid11} />
      <Grid item size={design.Grid11} />
      <Grid size={design.Grid5} pt={isMobile ? 2 : 0}>
        <ImageLoader
          src={image}
          alt={title}
          width={isMobile ? "98%" : "90%"}
          height={isMobile ? 215 : 354}
          borderRadius={4}
        />
      </Grid>
      <Grid size={design.Grid1} />
    </Grid>
  );
};

export default ServiceItem;

const design = {
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 20,
    lineHeight: "normal",
    marginTop: "3%",
    marginBottom: "3%",
    textAlign: "left",
    paddingRight: 3,
  },
  Medico: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 17,
    lineHeight: "normal",
    textAlign: "center",
  },
  TextTitulo: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 25,
      sm: 25,
      md: 40,
      lg: 40,
    },
    fontWeight: 700,
    textAlign: "left",
  },
  Button: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 18,
  },
  Grid1: { xs: 1, md: 1, xl: 1, lg: 1 },
  Grid5: { xs: 10, md: 5, xl: 5, lg: 5 },
  Grid6: { xs: 5, md: 5, xl: 5, lg: 5 },
  Grid7: { xs: 7, md: 5, xl: 5, lg: 5 },
  Grid11: { xs: 1, md: 0, xl: 0, lg: 0 },
};
